// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mFw4K","right":"styles_right__1gzOS"};